import { useMemo } from 'react';

import { ICartEntry } from '@rbi-ctg/menu';
import { useCart } from 'hooks/use-cart';
import { useIsEditCartEnabled } from 'hooks/use-is-edit-cart-enabled';
import { useFavoritesContext } from 'state/favorites';
import { useMenuContext } from 'state/menu';

import useProductWizardFlow from './use-product-wizard-flow';

export const useEditingCartEntry = (): ICartEntry | undefined => {
  const { cartEntries } = useCart();
  const { isOffer } = useMenuContext();
  const { isEdit, isFavorite, cartIdEditing } = useProductWizardFlow();
  const enableEditCart = useIsEditCartEnabled({ cartHasIncentive: isOffer });

  const currentCartEntry = useMemo(() => {
    return cartEntries.find((entry: ICartEntry) => entry.cartId === cartIdEditing);
  }, [cartEntries, cartIdEditing]);

  const {
    currentCartEntry: currentFavoriteEntry,
    tempFavorite: currentFavorite,
  } = useFavoritesContext();

  // Editing a Favorite Entry
  if (isFavorite && currentFavorite) {
    return currentFavoriteEntry;
  }
  // Editing a Cart Entry
  if (enableEditCart && isEdit && !!cartIdEditing) {
    return currentCartEntry;
  }

  return;
};
